import styled from 'styled-components';

import Button from '@components/Button';

export const Container = styled.div<{ isToggled: boolean }>`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: ${({ isToggled }) => (isToggled ? 'center' : 'flex-end')};
  align-items: stretch;
  max-width: 1200px;
  padding: 10px 0;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`;

export const PriceDetailsContainer = styled.div`
  flex: 1;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 15px;
  }
`;

export const TotalPriceWrapper = styled.div`
  display: flex;
  align-items: flex-end;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 10px 15px;
    justify-content: space-between;
    align-items: center;
  }
`;

export const VerticalSeparator = styled.div`
  height: auto;
  margin: 0 40px;
  border: solid ${({ theme }) => theme.palette.grey300} 1px;
  display: flex;
  flex-flow: column;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: row;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 5px;
  }
`;

export const TotalPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding-right: 30px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-right: 0;
    justify-content: center;
    align-items: flex-start;
    line-height: 1.3;
  }
`;

export const TotalPriceTitleContainer = styled.div`
  font-size: 12px;
  font-weight: bold;
  opacity: 0.75;
  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
`;

export const ActionButton = styled(Button)`
  width: 220px;
  height: 58px !important;
  font-weight: bold;
  font-size: 18px !important;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 155px;
    height: 40px !important;
    font-size: 14px !important;
  }
`;
